import { useApolloClient } from '@apollo/client';

export const useRefetchQueries = () => {
  const client = useApolloClient();

  const getRefetchQueries = (queries: string[]) => {
    const observableQueries = client.getObservableQueries();
    return queries.filter(query =>
      Array.from(observableQueries.values()).some(q => q.queryName === query)
    );
  };

  return { getRefetchQueries };
};
